<template>
	<div id="app">
		<router-view />
	</div>
</template>

<script>
export default {};
</script>

<style src="@/assets/styles/styles.scss" lang="scss"></style>
